<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="iconSize"
    :height="iconSize"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="veke-icon lucide"
  >
    <path d="M14 12V9.6C14 9.17565 13.8495 8.76869 13.5816 8.46863C13.3137 8.16857 12.9503 8 12.5714 8H5.42857C5.04969 8 4.68633 8.16857 4.41842 8.46863C4.15051 8.76869 4 9.17565 4 9.6V12" />
    <path d="M2 13.3333V16.6667C2 17.0203 2.16389 17.3594 2.45561 17.6095C2.74733 17.8595 3.143 18 3.55556 18H14.4444C14.857 18 15.2527 17.8595 15.5444 17.6095C15.8361 17.3594 16 17.0203 16 16.6667V13.3333C16 12.9797 15.8361 12.6406 15.5444 12.3905C15.2527 12.1405 14.857 12 14.4444 12C14.0319 12 13.6362 12.1405 13.3445 12.3905C13.0528 12.6406 12.8889 12.9797 12.8889 13.3333V14.6667H5.11111V13.3333C5.11111 12.9797 4.94722 12.6406 4.6555 12.3905C4.36378 12.1405 3.96811 12 3.55556 12C3.143 12 2.74733 12.1405 2.45561 12.3905C2.16389 12.6406 2 12.9797 2 13.3333Z" />
    <path d="M4 18V20" />
    <path d="M14 18V20" />
    <path d="M23 21L1 21" stroke-linecap="square" />
    <path d="M17.5 3H20.5L22 8H16L17.5 3Z" />
    <path d="M19 8.94446V19.7778" stroke-linecap="square" />
    <path d="M17.375 20.7778H20.625" />
  </svg>
</template>

<script>
import Icon from './Icon'

export default Icon('MilieuIcon')
</script>
